if (!customElements.get('card-product-swatches')) {
  class CardProductSwatches extends HTMLElement {
    constructor() {
      super();
      this.swatchContainer = this.querySelector('.card-product__color-swatches');
      this.swatchButtons = this.swatchContainer?.querySelectorAll('.card-product__swatch-button');
      this.productCard = this.closest('.card-wrapper');
      this.productImage = this.productCard?.querySelector('.card__media .primary-media');
      this.secondaryImage = this.productCard?.querySelector('.card__media .secondry-media');
      this.skus = this.productCard?.querySelectorAll('.card__sku')
      this.init();
    }

    init() {
      if (!this.productImage || !this.swatchButtons || this.swatchButtons.length === 0) return;

      // Prevent clicks on swatch container from propagating
      if (this.swatchContainer) {
        this.swatchContainer.addEventListener('click', (e) => {
          // Only stop propagation if clicking on a swatch button
          if (e.target.closest('.card-product__swatch-button')) {
            e.stopPropagation();
          }
        });
      }

      this.swatchButtons.forEach((button) => {
        button.addEventListener('click', this.handleSwatchClick.bind(this));
      });

      // Initialize image to match the active swatch on page load
      this.initializeActiveSwatchImage();
    }

    initializeActiveSwatchImage() {
      // Find the active swatch button
      const activeButton = Array.from(this.swatchButtons).find(
        (btn) => btn.classList.contains('active') && !btn.disabled
      );

      // If no active button found, use the first enabled button
      const buttonToUse = activeButton || Array.from(this.swatchButtons).find((btn) => !btn.disabled);

      if (buttonToUse) {
        this.updateImages(buttonToUse);
      }
    }

    updateSku(button) {
      let skuData = button.dataset.sku;
      if(skuData) {
        this.skus.forEach(element => {
          element.textContent = `SKU#: ${skuData}`;
        });
      }
    }

    updateImages(button) {
      // Ensure we're working with the correct product card (re-query to be safe)
      const productCard = button.closest('.card-wrapper') || this.productCard;
      if (!productCard) {
        console.warn('Product card not found for button');
        return;
      }

      // Double-check we're in the right product card by matching product ID if available
      const swatchContainer = button.closest('.card-product__color-swatches');
      const productId = swatchContainer?.dataset?.productId;
      const cardWrapperId = swatchContainer?.dataset?.cardWrapperId;
      
      // Find images within this specific product card only
      const productImage = productCard.querySelector('.card__media .primary-media');
      const secondaryImage = productCard.querySelector('.card__media .secondry-media');
      
      if (!productImage) {
        console.warn('Primary image not found in product card');
        return;
      }

      // Update primary image
      if (productImage) {
        let imageSrcset = button.dataset.variantImageSrcset;
        let imageSrc = button.dataset.variantImageSrc;
        let imageSizes = button.dataset.variantImageSizes;
        let imageAlt = button.dataset.variantImageAlt;
        let imageWidth = button.dataset.variantImageWidth;
        let imageHeight = button.dataset.variantImageHeight;

        // If variant doesn't have primary image, use product featured image
        if (!imageSrc) {
          imageSrcset = button.dataset.productFeaturedImageSrcset;
          imageSrc = button.dataset.productFeaturedImageSrc;
          imageSizes = button.dataset.productFeaturedImageSizes;
          imageAlt = button.dataset.productFeaturedImageAlt;
          imageWidth = button.dataset.productFeaturedImageWidth;
          imageHeight = button.dataset.productFeaturedImageHeight;
        }

        if (imageSrc) {
          if (imageSrcset) {
            productImage.srcset = imageSrcset;
          }
          productImage.src = imageSrc;
          if (imageSizes) {
            productImage.sizes = imageSizes;
          }
          if (imageAlt) {
            productImage.alt = imageAlt;
          }
          if (imageWidth) {
            productImage.width = imageWidth;
          }
          if (imageHeight) {
            productImage.height = imageHeight;
          }
        }
      }

      // Update all product links (e.g., title, image links) to selected variant URL
      const variantUrl = button.dataset.variantUrl;
      if (variantUrl && productCard) {
        const productLinks = productCard.querySelectorAll('a.full-unstyled-link');
        productLinks.forEach((link) => {
          link.href = variantUrl;
        });
      }

      // Update secondary image: ONLY use a variant-specific secondary image.
      // If the selected variant has no secondary image, we hide the hover image
      // and remove the hover-effect class so we never show another color on hover.
      if (secondaryImage) {
        const mediaWrapper = secondaryImage.closest('.media');

        const secondarySrcset = button.dataset.variantSecondaryImageSrcset;
        const secondarySrc = button.dataset.variantSecondaryImageSrc;
        const secondarySizes = button.dataset.variantSecondaryImageSizes;
        const secondaryAlt = button.dataset.variantSecondaryImageAlt;
        const secondaryWidth = button.dataset.variantSecondaryImageWidth;
        const secondaryHeight = button.dataset.variantSecondaryImageHeight;

        if (secondarySrc) {
          // Show secondary image for this variant
          secondaryImage.style.display = '';

          // Ensure hover effect is enabled when a secondary image exists
          if (mediaWrapper) {
            mediaWrapper.classList.add('media--hover-effect');
          }

          if (secondarySrcset) {
            secondaryImage.srcset = secondarySrcset;
          }
          secondaryImage.src = secondarySrc;
          if (secondarySizes) {
            secondaryImage.sizes = secondarySizes;
          }
          if (secondaryAlt) {
            secondaryImage.alt = secondaryAlt;
          }
          if (secondaryWidth) {
            secondaryImage.width = secondaryWidth;
          }
          if (secondaryHeight) {
            secondaryImage.height = secondaryHeight;
          }
        } else {
          // No secondary image for this variant → hide it to avoid wrong color on hover
          // secondaryImage.style.display = 'none';
          // secondaryImage.removeAttribute('src');
          // secondaryImage.removeAttribute('srcset');

           // Remove hover effect when there is no secondary image
          if (mediaWrapper) {
            // mediaWrapper.classList.remove('media--hover-effect');
          }
        }
      }
    }

    handleSwatchClick(event) {
      event.preventDefault();
      event.stopPropagation();
      
      const button = event.currentTarget;
      
      if (button.disabled || button.classList.contains('active')) return;

      // Ensure button belongs to this product card
      const buttonProductCard = button.closest('.card-wrapper');
      if (buttonProductCard !== this.productCard) {
        console.warn('Button does not belong to this product card');
        return;
      }

      // Update active state - only for buttons in this product card
      this.swatchButtons.forEach((btn) => {
        if (btn.closest('.card-wrapper') === this.productCard) {
          btn.classList.remove('active');
        }
      });
      button.classList.add('active');

      // Update both primary and secondary images
      this.updateImages(button);
      this.updateSku(button);
    }
  }

  customElements.define('card-product-swatches', CardProductSwatches);
}

// Initialize swatches for all product cards on page load
function initializeSwatches() {
  const swatchElements = document.querySelectorAll('card-product-swatches');
  swatchElements.forEach((element) => {
    if (!element.initialized) {
      element.initialized = true;
    }
  });
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeSwatches);
} else {
  initializeSwatches();
}

// Also initialize for dynamically loaded content (e.g., AJAX filters)
if (typeof MutationObserver !== 'undefined') {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          const swatchElements = node.querySelectorAll?.('card-product-swatches');
          if (swatchElements && swatchElements.length > 0) {
            swatchElements.forEach((element) => {
              if (!element.initialized) {
                element.initialized = true;
              }
            });
          }
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

